var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.color,"text":_vm.text,"disabled":_vm.saving,"loading":_vm.saving},on:{"click":_vm.onClick},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('v-progress-circular',{attrs:{"indeterminate":"","width":2,"size":24,"color":_vm.colorLoading}})]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }